let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("245Fj")).then(() => parcelRequire('c81zX'));